export const TABLE_DATA = {
  heading: "Bare-Metal Servers vs. Virtualized Environments",
  columns: ["Bare-Metal Servers", "Virtualized Servers"],
  data: [
    {
      feature: "Performance",
      "Bare-Metal Servers": "✅ Uncompromised, direct hardware access",
      "Virtualized Servers": "❌ Shared resources with hypervisor overhead",
    },
    {
      feature: "Latency",
      "Bare-Metal Servers": "✅ Ultra-low latency",
      "Virtualized Servers": "❌ Higher due to virtualization layer",
    },
    {
      feature: "Customization",
      "Bare-Metal Servers": "✅ Full control over CPU, RAM, storage",
      "Virtualized Servers": "❌ Limited by virtualized instances",
    },
    {
      feature: "Security & Compliance",
      "Bare-Metal Servers": "✅ Maximum security (single tenant)",
      "Virtualized Servers": "❌ Multi-tenant environment introduces security risks",
    },
    {
      feature: "Best For",
      "Bare-Metal Servers": "AI, HPC, Big Data, Cloud Gaming",
      "Virtualized Servers": "General-purpose applications",
    },
  ],
};
